import { useEffect } from "react";

export function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} — NimbleNode` : 'NimbleNode — AI Content Creation Platform';
    return () => { document.title = prev; };
  }, [title]);
}
